import "../Custom.css"
import { Link } from "react-router-dom"
import {
  HOMEPAGE_CORP_SERVICE_BANNER,
  HOMEPAGE_DIGITAL_SERVICE_BANNER,
  HOMEPAGE_INT_COMMERCE_BANNER,
  HOMEPAGE_CONSULTANTS_SERVICE_BANNER,
  HOMEPAGE_ACCOUNTING_SERVICE_BANNER,
  HOMEPAGE_REAL_ESTATE_BANNER,
  HOMEPAGE_INVESTMENTS_BANNER,
} from "../utils/constants"

const Services = () => {
  const leftColumnData = [
    {
      title: "Corporate Service Provider",
      companyName: "Morifar Corporate Service Provider LLC",
      desc: "specializes in company formation, nominee and trustee services, trust and foundation structuring, regulatory compliance, and corporate governance solutions.",
      imgPath: HOMEPAGE_CORP_SERVICE_BANNER,
      pageLink: "/corporate-service-provider",
    },
    {
      title: "Investments",
      companyName: "Morifar Investments LLC",
      desc: "- a premier & among the largest private investment companies in Dubai, stands on credibility, financial strength, and governance, delivering innovative global investment opportunities, shaping industries, and promoting sustainable development and long-term success.",
      imgPath: HOMEPAGE_INVESTMENTS_BANNER,
      pageLink: "/investments",
    },
    {
      title: "International Commerce",
      companyName:
        "Morifar General Trading LLC (UAE) & Morifar Exim Pvt Ltd (India)",
      desc: "is the trading arm of the group. The company sources and trades Garments, Clothing & Accessories.",
      imgPath: HOMEPAGE_INT_COMMERCE_BANNER,
      pageLink: "/international-commerce",
    },
  ]

  const rightColumnData = [
    {
      title: "Real Estate",
      companyName: "Morifar Real Estate LLC",
      desc: "is a dynamic real estate investment and development company, specializing in acquiring, managing, and developing high-quality residential, commercial, and mixed-use properties locally and internationally, backed by strong capital and a forward-looking strategy for investors, homeowners, and businesses.",
      imgPath: HOMEPAGE_REAL_ESTATE_BANNER,
      pageLink: "/real-estate",
    },
    {
      title: "Overseas Business Consultants",
      companyName: "Advani Overseas Consultants (UK)",
      desc: "helps businesses with personalized advice, smart strategies, and practical solutions. We empower clients to tackle challenges, meet goals, and grow in today's competitive business world.",
      imgPath: HOMEPAGE_CONSULTANTS_SERVICE_BANNER,
      pageLink: "/overseas-business-consultants",
    },
    // {
    //   title: "Accounting & Bookkeeping",
    //   companyName: "Al Asr International LLC (UAE)",
    //   desc: "provides e-governance and PRO services, VAT related services such as tax registration, return-filing, consultancy and accounting.",
    //   imgPath: HOMEPAGE_ACCOUNTING_SERVICE_BANNER,
    //   pageLink: "/accounting-and-bookkeeping",
    // },
    {
      title: "Digital Solutions",
      companyName: "Morifar International Limited (UK)",
      desc: "provides creative digital solutions for business and branding, website creation, content management, application development and online marketing.",
      imgPath: HOMEPAGE_DIGITAL_SERVICE_BANNER,
      pageLink: "/digital-solutions",
    },
  ]

  return (
    <>
      {/* animation */}
      <div className="bg"></div>
      <div className="bg bg2"></div>
      <div className="bg bg3"></div>

      <div className="container pb-5 mb-5 bg-black bg-opacity-100">
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="row px-5 py-3 text-center animated animatedFadeInUp fadeInUp animation-delay3">
              <h2
                className="fw-bold d-none d-md-block text-secondary"
                style={{ fontSize: "60px" }}
              >
                Services<span className="text-warning">.</span>
              </h2>
              <h2
                className="fw-bold d-block d-md-none text-secondary"
                style={{ fontSize: "40px" }}
              >
                Services<span className="text-warning">.</span>
              </h2>
            </div>

            {leftColumnData.map((data, index) => (
              <>
                <div className="row p-5 animated animatedFadeInUp fadeInUp animation-delay3">
                  <img
                    src={data.imgPath}
                    className="transform"
                    alt={data.title}
                    height="auto"
                    width="auto"
                  />
                </div>
                <Link to={data.pageLink} style={{ textDecoration: "none" }}>
                  <div className="row px-5 animated animatedFadeInUp fadeInUp animation-delay4 shadow-lg">
                    <p className="text-white border border-warning text-center">
                      {data.title}
                    </p>
                    <p className="text-center" style={{ color: "#b0b3b6ff" }}>
                      <small>
                        <span className="text-warning">{data.companyName}</span>{" "}
                        {data.desc}
                      </small>
                    </p>
                  </div>
                </Link>
              </>
            ))}
          </div>

          <div className="col-12 col-md-6">
            {rightColumnData.map((data, index) => (
              <>
                <div className="row p-5 animated animatedFadeInUp fadeInUp animation-delay5">
                  <img
                    src={data.imgPath}
                    className="transform"
                    alt={data.title}
                    height="auto"
                    width="auto"
                  />
                </div>
                <Link to={data.pageLink} style={{ textDecoration: "none" }}>
                  <div className="row px-5 animated animatedFadeInUp fadeInUp animation-delay6 shadow-lg">
                    <p className="text-white border border-warning text-center">
                      {data.title}
                    </p>
                    <p className="text-center" style={{ color: "#b0b3b6ff" }}>
                      <small>
                        <span className="text-warning">{data.companyName}</span>{" "}
                        {data.desc}
                      </small>
                    </p>
                  </div>
                </Link>
              </>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default Services
